/* global customElements, HTMLElement, requestAnimationFrame */

import * as focusTrap from 'focus-trap'

class Header extends HTMLElement {
  connectedCallback () {
    this.$toggle = this.querySelector('.js-header__menu-mobile-toggle')
    this.$logo = this.querySelector('.js-header__logo')
    this.$toggleIcon = this.querySelector('.js-header__menu-mobile-toggle-icon')
    this.$popup = this.querySelector('.js-header__menu-mobile-popup')
    this.$container = this.querySelector('.js-header__container')
    this.$topElement = this.dataset.topElement
      ? document.querySelector(this.dataset.topElement)
      : null

    this.focusTrap = focusTrap.createFocusTrap(this, {
      escapeDeactivates: true,
      clickOutsideDeactivates: true,
      onDeactivate: () => {
        this.toggleMenu(false)
      },
      initialFocus: () => {
        this.focus()
        return false
      }
    })

    this.$toggle.addEventListener('click', () => this.toggleMenu())

    this.mediaQuery = window.matchMedia(`(min-width: ${this.breakpoint})`)
    this.mediaQuery.addEventListener('change', (e) => {
      if (e.matches) {
        // hide mobile menu when switching to desktop
        this.toggleMenu(false)
      }
    })

    // window.addEventListener('scroll', debounce(() => {
    //   const scrollY = window.scrollY
    //   const isTop = scrollY < this.$container.getBoundingClientRect().height
    //   this.classList.toggle('is-scrolled-down', !isTop)
    // }, 100)
    window.addEventListener('scroll', () => this.handleWindowScroll())
  }

  handleWindowScroll () {
    if (this._scrollRaf) return
    this._scrollRaf = requestAnimationFrame(() => {
      const scrollY = window.scrollY
      const isTop = scrollY < this.$container.getBoundingClientRect().height
      this.classList.toggle('is-scrolled-down', !isTop)
      this._scrollRaf = null

      if (this.$topElement) {
        const topElementSpec = this.$topElement.getBoundingClientRect()
        const logoSpec = this.$logo.getBoundingClientRect()

        this.classList.toggle('is-not-top', topElementSpec.bottom < logoSpec.top)
      }
    })
  }

  get breakpoint () {
    const style = window.getComputedStyle(this)
    return style.getPropertyValue('--header--breakpoint')
  }

  get isOpen () {
    return this.$toggle.getAttribute('aria-expanded') === 'true'
  }

  toggleMenu (force = null) {
    const oldState = this.isOpen
    const newState = typeof force === 'boolean' ? force : !oldState

    if (oldState === newState) {
      return
    }

    this.$toggle.setAttribute('aria-expanded', newState)
    this.$popup.inert = !newState

    if (newState) {
      this.focusTrap.activate()
    } else {
      this.focusTrap.deactivate()
    }
  }
}

customElements.define('dj-header', Header)
